<!-- 我的电站 -->
<template>
    <div class="power-station-page">
        <main class="content-wrap">
            <PageTop />
            <section class="dashboard-shell">
                <div class="dashboard-grid">
                    <div class="left-panel">
                        <article class="card info-card info-card-left" v-loading="loadingIncomeRanking">
                            <div class="panel-header">
                                <div class="panel-title">
                                    <span class="panel-accent"></span>
                                    <span class="panel-title-text">基础信息</span>
                                </div>
                            </div>

                            <div class="panel-big-row">
                                <div class="big-stat">
                                    <div class="big-label">{{ baseInfo.topLeft.label }}</div>
                                    <div class="big-value">
                                        <span class="big-number">{{ incomeRanking.eLinkCount }}</span>
                                        <span class="big-unit">{{ baseInfo.topLeft.unit }}</span>
                                    </div>
                                </div>
                                <div class="big-divider"></div>
                                <div class="big-stat">
                                    <div class="big-label">{{ baseInfo.topRight.label }}</div>
                                    <div class="big-value">
                                        <span class="big-number">{{ incomeRanking.eBlockCount }}</span>
                                        <span class="big-unit">{{ baseInfo.topRight.unit }}</span>
                                    </div>
                                </div>
                            </div>

                            <div class="panel-bottom-row">
                                <div v-for="item in baseInfoBottomList" :key="item.key" class="bottom-stat">
                                    <div class="big-label">{{ item.label }}</div>
                                    <div class="bottom-value">
                                        <span class="big-number">{{ item.value }}</span>
                                        <span class="big-unit">{{ item.unit }}</span>
                                    </div>
                                </div>
                            </div>
                        </article>
                        <article class="card ranking-card mps-ranking-stack" v-loading="loadingIncomeRanking">
                            <div class="panel-title">
                                <span class="panel-accent"></span>
                                <span class="panel-title-text">收益排名</span>
                            </div>
                            <div class="mps-table-wrap">
                                <div class="mps-revenue-table-inner">
                                    <v-table density="compact"
                                        class="bg-transparent flex-grow-1 gm-table mps-table mps-revenue-table"
                                        style="width: 100%">
                                        <thead>
                                            <tr>
                                                <th style="width: 50%">电站名称</th>
                                                <th class="text-end" style="">累计收益</th>
                                                <th class="text-end" style="">投运日期</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="item in rankPageItems" :key="item.rankIndex">
                                                <td class="mps-station-cell">
                                                    <div class="mps-station-name">
                                                        <span class="mps-station-text"
                                                            :title="item.name != null && item.name !== '' ? String(item.name) : undefined">{{
                                                                item.name }}</span>
                                                    </div>
                                                </td>
                                                <td class="text-end">{{ item.value }}</td>
                                                <td class="text-end">{{ item.time }}</td>
                                            </tr>
                                        </tbody>
                                    </v-table>
                                </div>
                            </div>
                            <div class="pagination-container mps-revenue-pagination">
                                <div class="pagination-controls">
                                    <div v-if="rankTotalPages > 1" class="rank-pager" @mouseenter="pauseRankCarousel"
                                        @mouseleave="resumeRankCarousel">
                                        <button class="rank-arrow" type="button" aria-label="上一页" @click="rankPrev">
                                            ‹
                                        </button>
                                        <div class="rank-dots">
                                            <button v-for="p in rankVisiblePages" :key="`rank-page-${p}`" type="button"
                                                class="rank-dot" :class="{ active: p === rankPage }"
                                                :aria-label="`第${p}页`" @click="handleRankDotClick(p)" />
                                        </div>
                                        <button class="rank-arrow" type="button" aria-label="下一页" @click="rankNext">
                                            ›
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </article>
                    </div>

                    <div class="center-panel" v-loading="loadingStationData || loadingIncomeStations">
                        <div class="map-overlay">
                            <div class="map-overlay-title">
                                <span class="map-overlay-pin" aria-hidden="true" />
                                <span class="map-overlay-title-text">中国</span>
                            </div>
                            <div class="map-overlay-row">
                                <span class="map-overlay-label">电站数量：</span>
                                <span class="map-overlay-value">{{ stationData.stationNum || 0 }}个</span>
                            </div>
                            <div class="map-overlay-row">
                                <span class="map-overlay-label">装机容量：</span>
                                <span class="map-overlay-value">{{ stationCapacityDisplay }}</span>
                            </div>
                            <!-- <div class="map-overlay-row">
                            <span class="map-overlay-label">今日收益：</span>
                            <span class="map-overlay-value">63万元</span>
                        </div> -->
                        </div>

                        <!-- 地图打点与连线 -->
                        <div class="map-connection-layer" aria-hidden="true">

                            <img class="map-marker-icon" :src="mapPointIcon" alt="" />
                        </div>

                        <div class="map-footer">
                            <div class="map-footer-item">
                                <img class="map-footer-icon" :src="co2Icon" alt="CO2" />
                                <div class="map-footer-value">
                                    <span class="num">{{ mapFooterStats.co2.num }}</span><span class="unit">({{
                                        mapFooterStats.co2.unit
                                        }})</span>
                                </div>
                                <div class="map-footer-label">CO2</div>
                            </div>
                            <div class="map-footer-item">
                                <img class="map-footer-icon" :src="treeIcon" alt="森林砍伐" />
                                <div class="map-footer-value">
                                    <span class="num">{{ mapFooterStats.tree.num }}</span><span class="unit">({{
                                        mapFooterStats.tree.unit
                                        }})</span>
                                </div>
                                <div class="map-footer-label">森林砍伐</div>
                            </div>
                            <div class="map-footer-item">
                                <img class="map-footer-icon" :src="coalIcon" alt="节约煤炭" />
                                <div class="map-footer-value">
                                    <span class="num">{{ mapFooterStats.coal.num }}</span><span class="unit">({{
                                        mapFooterStats.coal.unit
                                        }})</span>
                                </div>
                                <div class="map-footer-label">节约煤炭</div>
                            </div>
                        </div>
                    </div>

                    <div class="right-panel">
                        <article class="card info-card" v-loading="loadingIncomeData || loadingTodayIncome">
                            <div class="panel-header">
                                <div class="panel-title">
                                    <span class="panel-accent"></span>
                                    <span class="panel-title-text">收益信息</span>
                                </div>
                            </div>

                            <div class="income-box">
                                <div class="income-top-grid">
                                    <div v-for="item in incomeInfo.top" :key="item.label" class="income-top-item">
                                        <div class="big-label">{{ item.label }}</div>
                                        <div class="big-value">
                                            <span class="big-number">{{ item.value }}</span>
                                            <span class="big-unit">{{ item.unit }}</span>
                                        </div>
                                    </div>
                                </div>

                                <div class="income-bottom-grid">
                                    <div v-for="item in incomeInfo.bottom" :key="item.label" class="bottom-stat">
                                        <div class="big-label">{{ item.label }}</div>
                                        <div class="bottom-value">
                                            <span class="big-number">{{ item.value }}</span>
                                            <span class="big-unit">{{ item.unit }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </article>
                        <article class="card chart-card" v-loading="loadingIncomeData">
                            <div class="chart-head">
                                <div class="panel-title">
                                    <span class="panel-accent"></span>
                                    <span class="panel-title-text">统计曲线</span>
                                </div>

                                <div class="chart-tabs" aria-label="统计粒度切换">
                                    <button type="button" class="chart-tab"
                                        :class="{ 'is-active': timeRange === 'day' }" @click="onChartTabChange('day')">
                                        天
                                    </button>
                                    <button type="button" class="chart-tab"
                                        :class="{ 'is-active': timeRange === 'month' }"
                                        @click="onChartTabChange('month')">
                                        月
                                    </button>
                                    <button type="button" class="chart-tab"
                                        :class="{ 'is-active': timeRange === 'year' }"
                                        @click="onChartTabChange('year')">
                                        年
                                    </button>
                                </div>
                            </div>

                            <div class="chart-section">
                                <div class="chart-section-title">收益分析</div>
                                <div class="chart-block">
                                    <VChart class="chart" :option="revenueBarOption" autoresize />
                                </div>
                            </div>

                            <div class="chart-section">
                                <div class="chart-section-top">
                                    <div class="chart-section-title">充放电量统计</div>
                                </div>

                                <div class="chart-block chart-block--area">
                                    <VChart class="chart" :option="completeLineOption" autoresize />
                                </div>
                            </div>
                        </article>
                    </div>
                </div>
            </section>
        </main>
    </div>
</template>

<script setup>
import { computed, onBeforeUnmount, onMounted, ref, watch } from 'vue'
import dayjs from 'dayjs'
import { graphic } from 'echarts'
import PageTop from '@/components/PageTop/index.vue'
import { getMonthIncomeAndPower } from '@/api/workbench/index.js'
import { getTodayIncome, getStationEnergyStat } from '@/api/business-operations/index.js'
import { getIncomeRanking, getIncomeStations } from '@/api/my-station/index.js'
import { getStationData } from '@/api/workbench/index.js'
import co2Icon from '@/assets/co2.png'
import treeIcon from '@/assets/tree.png'
import coalIcon from '@/assets/coal.png'
import mapPointIcon from '@/assets/font_icon.png'
import { formatterCapacity } from '@/utils/fortmatter'

const baseInfo = {
    topLeft: { label: 'eLink数量', value: '0', unit: '个' },
    topRight: { label: 'eBlock数量', value: '0', unit: '个' },
}

const incomeRaw = ref({})

const safeCount = (v) => {
    const n = Number(v)
    return Number.isFinite(n) ? n : 0
}

const formatEnergy = (num) => {
    const n = Number(num)
    if (!Number.isFinite(n)) return { value: '0', unit: 'kWh' }
    if (n >= 1_000_000) return { value: (n / 1_000_000).toFixed(2), unit: 'GWh' }
    if (n >= 1_000) return { value: (n / 1_000).toFixed(2), unit: 'MWh' }
    return { value: String(Math.round(n)), unit: 'kWh' }
}

const formatMoney = (num) => {
    const n = Number(num)
    if (!Number.isFinite(n)) return { value: '0', unit: '元' }
    if (n >= 10_000) return { value: (n / 10_000).toFixed(0), unit: '万元' }
    return { value: String(Math.round(n)), unit: '元' }
}

/** 今日收益：仅做 元/万元 换算（≥1万显示万元） */
const formatTodayIncomeMoney = (num) => {
    const n = Number(num)
    if (!Number.isFinite(n)) return { value: '0.00', unit: '元' }
    if (n >= 10_000) return { value: (n / 10_000).toFixed(2), unit: '万元' }
    return { value: n.toFixed(2), unit: '元' }
}

/**
 * 统计条数量格式：
 * - 小于等于 1 万：保留 2 位小数，单位原样
 * - 大于 1 万：数值除以 1 万，单位前增加“万”（例如 t -> 万t）
 */
const formatWanStat = (num, unit) => {
    const n = Number(num)
    if (!Number.isFinite(n)) return { num: '0.00', unit }
    if (Math.abs(n) >= 10_000) return { num: (n / 10_000).toFixed(2), unit: `万${unit}` }
    return { num: n.toFixed(2), unit }
}

const pickFirstFiniteNumber = (obj, keys) => {
    for (const key of keys) {
        const v = obj?.[key]
        const n = Number(v)
        if (Number.isFinite(n)) return n
    }
    return 0
}

const fetchTodayIncome = async ({ showLoading = true } = {}) => {
    if (showLoading) loadingTodayIncome.value = true
    try {
        const res = await getTodayIncome()
        if (res.code === 200 && res.data) {
            todayIncome.value = Number(res.data.todayIncome ?? 0)
        }
    } finally {
        if (showLoading) loadingTodayIncome.value = false
    }
}
const todayIncome = ref(0)

let todayIncomeTimer = null
const todayIncomeDisplay = ref(0)
let todayIncomeAnimInit = false
let todayIncomeRafId = 0

function animateTodayIncomeTo(target, duration = 900) {
    const from = Number(todayIncomeDisplay.value) || 0
    const to = Number(target) || 0

    if (!Number.isFinite(to) || !Number.isFinite(from) || Math.abs(to - from) < 0.0001) {
        todayIncomeDisplay.value = to
        return
    }

    if (todayIncomeRafId) cancelAnimationFrame(todayIncomeRafId)

    const start = performance.now()
    const delta = to - from

    const step = (now) => {
        const t = Math.min(1, (now - start) / duration)
        // cubic out easing: starts quickly, slows down at the end
        const eased = 1 - Math.pow(1 - t, 3)
        const v = from + delta * eased
        todayIncomeDisplay.value = v
        if (t < 1) {
            todayIncomeRafId = requestAnimationFrame(step)
            return
        }
        todayIncomeRafId = 0
        todayIncomeDisplay.value = to
    }

    todayIncomeRafId = requestAnimationFrame(step)
}

watch(
    () => todayIncome.value,
    (val) => {
        const target = Number(val) || 0
        if (!todayIncomeAnimInit) {
            todayIncomeDisplay.value = target
            todayIncomeAnimInit = true
            return
        }
        animateTodayIncomeTo(target)
    }
)
const incomeInfo = computed(() => {
    const d = incomeRaw.value || {}
    const sumIncome = pickFirstFiniteNumber(d, ['sum_income', 'sumIncome'])
    const yesterdayIncomeTotal = pickFirstFiniteNumber(d, ['yesterdayIncomeTotal', 'yesterday_income_total'])
    const yesterdayPvIncome = pickFirstFiniteNumber(d, [
        'yesterdayPvIncome',
        'yesterday_pv_income',
        'yesterdayPhotovoltaicIncome'
    ])

    const sumPositive = pickFirstFiniteNumber(d, ['sum_positive', 'sumPositive'])
    const sumReverse = pickFirstFiniteNumber(d, ['sum_reverse', 'sumReverse'])
    const yesterdayPositiveTotal = pickFirstFiniteNumber(d, [
        'yesterdayPositiveTotal',
        'yesterday_positive_total'
    ])
    const yesterdayReverseTotal = pickFirstFiniteNumber(d, [
        'yesterdayReverseTotal',
        'yesterday_reverse_total'
    ])

    const sumIncomeDisplay = formatMoney(sumIncome)
    const yesterdayIncomeDisplay = formatMoney(yesterdayIncomeTotal)
    const todayIncomeMoney = formatTodayIncomeMoney(todayIncomeDisplay.value)

    const sumPositiveDisplay = formatEnergy(sumPositive)
    const sumReverseDisplay = formatEnergy(sumReverse)
    const yesterdayPositiveDisplay = formatEnergy(yesterdayPositiveTotal)
    const yesterdayReverseDisplay = formatEnergy(yesterdayReverseTotal)
    return {
        top: [
            { label: '累计收益', value: sumIncomeDisplay.value, unit: sumIncomeDisplay.unit },
            { label: '昨日收益', value: yesterdayIncomeDisplay.value, unit: yesterdayIncomeDisplay.unit },
            {
                label: '今日实时收益',
                value: todayIncomeMoney.value,
                unit: todayIncomeMoney.unit
            }
        ],
        bottom: [
            { label: '累计充电', value: sumPositiveDisplay.value, unit: sumPositiveDisplay.unit },
            { label: '累计放电', value: sumReverseDisplay.value, unit: sumReverseDisplay.unit },
            { label: '昨日充电', value: yesterdayPositiveDisplay.value, unit: yesterdayPositiveDisplay.unit },
            { label: '昨日放电', value: yesterdayReverseDisplay.value, unit: yesterdayReverseDisplay.unit }
        ]
    }
})

const formatIncomeDisplay = (v) => {
    const n = Number(v)
    if (!Number.isFinite(n)) return '0'
    if (n >= 10_000) return `${(n / 10_000).toFixed(0)}万`
    return n.toFixed(0)
}

const formatDateOnly = (value) => {
    if (!value) return ''
    const str = String(value)
    return str.includes('T') ? str.split('T')[0] : str
}

const TIME_FMT = 'YYYY-MM-DD HH:mm:ss'
/** 与统计曲线 Tab 一致：默认「月」 */
const timeRange = ref('month')
const loadingIncomeData = ref(false)
const loadingTodayIncome = ref(false)
const loadingIncomeRanking = ref(false)
const loadingIncomeStations = ref(false)
const loadingStationData = ref(false)

/**
 * 收益曲线 / 底部环保统计 共用时间范围
 * - 天：近一个月
 * - 月：近一年
 * - 年：自 2021-01-01 起至当前
 */
const getIncomeQueryTimeRange = (range) => {
    const end = dayjs().endOf('day').format(TIME_FMT)
    if (range === 'day') {
        const start = dayjs().subtract(1, 'month').startOf('day').format(TIME_FMT)
        return { startTime: start, endTime: end }
    }
    if (range === 'month') {
        const start = dayjs().subtract(1, 'year').startOf('day').format(TIME_FMT)
        return { startTime: start, endTime: end }
    }
    const start = dayjs('2021-01-01').startOf('day').format(TIME_FMT)
    return { startTime: start, endTime: end }
}

/**
 * myStation `/incomeAndPower` 接口：后端 type 为 Integer。
 * 传字符串如 `month` 会被误绑定到日期参数，出现 Incorrect DATETIME value: 'm'。
 * 历史版本固定 `type: 1`，与默认「月」Tab 一致，故 month → 1；日/年为扩展枚举（若后端不同需再对齐）。
 */
const getIncomeStationsApiType = (range) => {
    if (range === 'month') return 1
    if (range === 'day') return 2
    if (range === 'year') return 3
    return 1
}

const formatXAxisByRange = (date, range) => {
    const d = dayjs(date)
    if (!d.isValid()) return '--'
    return range === 'day' ? d.format('MM-DD') : d.format('YYYY-MM')
}

const revenueXDate = ref([])
const revenueBarData = ref([])

const chargeAndDischargeChartData = ref({
    chargeData: [],
    disChargeData: []
})

const inComeChartData = ref({
    xAxisData: []
})

const fetchIncomAndPower = async (range) => {
    loadingIncomeData.value = true
    try {
        const params = { ...getIncomeQueryTimeRange(range), type: range }
        const res = await getMonthIncomeAndPower(params)
        const list = res?.data?.list ?? []
        incomeRaw.value = res?.data ?? {}

        revenueXDate.value = list.map((it) => formatXAxisByRange(it?.date, range))
        revenueBarData.value = list.map((it) => Number(it?.sum_income ?? 0))
        inComeChartData.value.xAxisData = revenueXDate.value

        chargeAndDischargeChartData.value.chargeData = list.map((it) =>
            Number(it?.sum_positive ?? 0)
        )
        chargeAndDischargeChartData.value.disChargeData = list.map((it) =>
            Number(it?.sum_reverse ?? 0)
        )
    } finally {
        loadingIncomeData.value = false
    }
}

const onChartTabChange = async (next) => {
    if (timeRange.value === next) return
    timeRange.value = next
    await fetchIncomAndPower(next)
    await fetchIncomeStations()
}

/** 收益图：元 / 万元 / 亿元（与 workbench/OP 一致） */
function pickRevenueChartScale(maxAbsYuan) {
    const n = Math.abs(Number(maxAbsYuan)) || 0
    if (n >= 1e8) return { divisor: 1e8, unitName: '亿元' }
    if (n >= 1e4) return { divisor: 1e4, unitName: '万元' }
    return { divisor: 1, unitName: '元' }
}

const KWH_PER_MWH = 1000
const KWH_PER_GWH = 1_000_000

/** 充放电曲线：kWh / MWh / GWh（与 workbench/OP 一致） */
function pickChargeDischargeEnergyScale(maxAbsKwh) {
    const n = Math.abs(Number(maxAbsKwh)) || 0
    if (n >= KWH_PER_GWH) return { divisor: KWH_PER_GWH, unit: 'GWh' }
    if (n >= KWH_PER_MWH) return { divisor: KWH_PER_MWH, unit: 'MWh' }
    return { divisor: 1, unit: 'kWh' }
}

const revenueBarOption = computed(() => {
    const rawIncome = revenueBarData.value || []
    const incomeNums = rawIncome.map((v) => Number(v)).filter((v) => Number.isFinite(v))
    const maxIncomeYuan = incomeNums.length ? Math.max(...incomeNums.map((v) => Math.abs(v))) : 0
    const revScale = pickRevenueChartScale(maxIncomeYuan)
    const revDiv = revScale.divisor
    const revenueScaled = rawIncome.map((v) => (Number(v) || 0) / revDiv)

    return {
        grid: { top: 30, bottom: 0, left: 12, right: 16, containLabel: true },
        xAxis: {
            type: 'category',
            data: revenueXDate.value,
            axisLabel: {
                fontSize: 10,
                color: 'rgba(46,46,46,0.6)'
            },
            axisLine: { show: false },
            axisTick: { show: false }
        },
        yAxis: {
            type: 'value',
            name: `收益(${revScale.unitName})`,
            nameLocation: 'end',
            nameTextStyle: {
                color: 'rgba(145, 147, 160, 0.6)',
                fontSize: 11
            },
            axisLine: { show: false },
            axisTick: { show: false },
            splitLine: { lineStyle: { color: 'rgba(0, 0, 0, 0.06)' } },
            axisLabel: {
                color: 'rgba(145, 147, 160, 0.6)',
                fontSize: 11,
                formatter: (val) => {
                    const n = Number(val)
                    if (!Number.isFinite(n)) return String(val)
                    if (revDiv === 1) return Math.abs(n) >= 1000 ? n.toLocaleString('zh-CN') : String(n)
                    return n.toLocaleString('zh-CN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                }
            }
        },
        tooltip: {
            trigger: 'axis',
            formatter: (params) => {
                const arr = Array.isArray(params) ? params : [params]
                if (!arr.length) return ''
                const p = arr[0]
                const name = p?.axisValueLabel ?? p?.axisValue ?? ''
                const v = p?.value
                const num = Number(v)
                let display = '--'
                if (Number.isFinite(num)) {
                    if (revDiv === 1) {
                        display = Number.isInteger(num)
                            ? String(num)
                            : num.toLocaleString('zh-CN', { minimumFractionDigits: 0, maximumFractionDigits: 2 })
                    } else {
                        display = num.toLocaleString('zh-CN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                    }
                }
                const u = revScale.unitName
                return `${name}<br/>收益：${display} ${u}`
            }
        },
        series: [
            {
                type: 'bar',
                data: revenueScaled,
                barWidth: timeRange.value === 'day' ? 8 : 14,
                itemStyle: { color: '#3A68FF', borderRadius: [4, 4, 0, 0] }
            }
        ]
    }
})

const completeLineOption = computed(() => {
    const chargeRaw = chargeAndDischargeChartData.value.chargeData || []
    const dischargeRaw = chargeAndDischargeChartData.value.disChargeData || []
    const allKwh = [...chargeRaw, ...dischargeRaw]
        .map((v) => Number(v))
        .filter((v) => Number.isFinite(v))
    const maxAbsKwh = allKwh.length ? Math.max(...allKwh.map((v) => Math.abs(v))) : 0
    const cdScale = pickChargeDischargeEnergyScale(maxAbsKwh)
    const cdDiv = cdScale.divisor
    const chargeScaled = chargeRaw.map((v) => (Number(v) || 0) / cdDiv)
    const dischargeScaled = dischargeRaw.map((v) => (Number(v) || 0) / cdDiv)

    return {
        color: ['#00D96E', '#3A68FF'],
        grid: { top: 25, bottom: 28, left: 12, right: 12, containLabel: true },
        xAxis: {
            type: 'category',
            data: inComeChartData.value.xAxisData,
            axisTick: { show: false },
            axisLine: { show: false },
            axisLabel: { color: 'rgba(145, 147, 160, 0.6)', fontSize: 11 }
        },
        yAxis: {
            type: 'value',
            name: cdScale.unit,
            nameLocation: 'end',
            nameGap: 8,
            nameTextStyle: {
                color: 'rgba(145, 147, 160, 0.6)',
                fontSize: 11
            },
            axisLine: { show: false },
            axisTick: { show: false },
            splitLine: { lineStyle: { color: 'rgba(0, 0, 0, 0.06)' } },
            axisLabel: {
                color: 'rgba(145, 147, 160, 0.6)',
                fontSize: 11,
                formatter: (val) => {
                    const n = Number(val)
                    if (!Number.isFinite(n)) return String(val)
                    if (cdDiv === 1) return Math.abs(n) >= 1000 ? n.toLocaleString('zh-CN') : String(n)
                    return n.toLocaleString('zh-CN', { minimumFractionDigits: 0, maximumFractionDigits: 2 })
                }
            }
        },
        tooltip: {
            trigger: 'axis',
            backgroundColor: '#fff',
            borderColor: 'transparent',
            borderRadius: 8,
            padding: [12, 14],
            extraCssText: 'box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);',
            textStyle: { color: '#2E2E2E', fontSize: 12 },
            axisPointer: {
                type: 'line',
                lineStyle: { type: 'dashed', color: 'rgba(0, 0, 0, 0.15)' }
            },
            formatter: (params) => {
                if (!params?.length) return ''
                const axisValue = params[0].axisValue
                const u = cdScale.unit
                let html = `<div style="font-weight:500;margin-bottom:8px;">${axisValue}</div>`
                params.forEach((p) => {
                    const val = p.value != null ? Number(p.value).toFixed(2) : '0'
                    html += `<div style="display:flex;align-items:center;gap:6px;margin-top:4px;">${p.marker}<span>${p.seriesName}: ${val} ${u}</span></div>`
                })
                return html
            }
        },
        legend: {
            show: true,
            top: 0,
            right: 0,
            itemWidth: 10,
            itemHeight: 10,
            itemGap: 20,
            icon: 'circle',
            textStyle: { color: 'rgba(100, 90, 120, 0.85)', fontSize: 12 },
            data: [
                {
                    name: '充电',
                    itemStyle: {
                        color: 'transparent',
                        borderColor: '#00D96E',
                        borderWidth: 2,
                        shadowBlur: 2,
                        shadowColor: 'rgba(0, 0, 0, 0.08)',
                        shadowOffsetY: 1
                    }
                },
                {
                    name: '放电',
                    itemStyle: {
                        color: 'transparent',
                        borderColor: '#528DFF',
                        borderWidth: 2,
                        shadowBlur: 2,
                        shadowColor: 'rgba(0, 0, 0, 0.08)',
                        shadowOffsetY: 1
                    }
                }
            ]
        },
        series: [
            {
                name: '充电',
                type: 'line',
                smooth: true,
                data: chargeScaled,
                symbol: 'circle',
                symbolSize: 6,
                showSymbol: false,
                emphasis: {
                    focus: 'series',
                    scale: 1.2,
                    itemStyle: { borderColor: '#fff', borderWidth: 2 }
                },
                lineStyle: { width: 2, color: '#00D96E' },
                itemStyle: { color: '#00D96E' },
                areaStyle: {
                    color: graphic.LinearGradient(0, 0, 0, 1, [
                        { offset: 0, color: 'rgba(0, 217, 110, 0.35)' },
                        { offset: 1, color: 'rgba(0, 217, 110, 0.02)' }
                    ])
                }
            },
            {
                name: '放电',
                type: 'line',
                smooth: true,
                data: dischargeScaled,
                symbol: 'circle',
                symbolSize: 6,
                showSymbol: false,
                emphasis: {
                    focus: 'series',
                    scale: 1.2,
                    itemStyle: { borderColor: '#fff', borderWidth: 2 }
                },
                lineStyle: { width: 2, color: '#3A68FF' },
                itemStyle: { color: '#3A68FF' },
                areaStyle: {
                    color: graphic.LinearGradient(0, 0, 0, 1, [
                        { offset: 0, color: '#0095FF00' },
                        { offset: 1, color: '#3A68FF66' }
                    ])
                }
            }
        ]
    }
})


const incomeRanking = ref({})
const fetchIncomeRanking = async () => {
    loadingIncomeRanking.value = true
    try {
        const res = await getIncomeRanking()
        if (res.code === 200 && res.data) {
            incomeRanking.value = res.data
        }
    } finally {
        loadingIncomeRanking.value = false
    }
}

const baseInfoBottomList = computed(() => {
    const d = incomeRanking.value || {}
    return [
        { key: 'photovoltaicCount', label: '光伏数量', value: safeCount(d.photovoltaicCount), unit: '个' },
        { key: 'chargePileCount', label: '充电桩数量', value: safeCount(d.chargePileCount), unit: '个' },
        { key: 'windPowerCount', label: '风电数量', value: safeCount(d.windPowerCount), unit: '个' }
    ]
})

const rankAllItems = computed(() => {
    const list = incomeRanking.value?.list
    const arr = Array.isArray(list) ? list : []
    const sorted = [...arr].sort((a, b) => Number(b?.income ?? 0) - Number(a?.income ?? 0))
    return sorted.map((row, idx) => ({
        /** 排序后下标，作列表 key；避免多条 stationId 为 0 时与 ?? 组合导致重复 key、少渲染一行 */
        rankIndex: idx,
        name: row?.name ?? '--',
        stationId: row?.stationId ?? row?.id,
        value: formatIncomeDisplay(row?.income),
        time: formatDateOnly(row?.commossioningTime ?? row?.commossioningTime)
    }))
})

/** 收益排名：取前 30 名作为数据池，分页展示（与运营管理收益列表一致） */
const RANK_TOP_N = 30
const rankPageSize = 7
const rankPage = ref(1)
const rankDotWindowSize = 7
const rankPageGroupStart = ref(1)

const rankTop30Pool = computed(() => rankAllItems.value.slice(0, RANK_TOP_N))

const rankTotalCount = computed(() => rankTop30Pool.value.length)

const rankTotalPages = computed(() => Math.max(1, Math.ceil(rankTotalCount.value / rankPageSize)))

watch(rankTotalPages, (tp) => {
    if (rankPage.value > tp) rankPage.value = tp
})

watch(
    () => incomeRanking.value?.list,
    () => {
        rankPage.value = 1
        rankPageGroupStart.value = 1
    },
    { deep: true }
)

const rankPageItems = computed(() => {
    const pool = rankTop30Pool.value
    const start = (rankPage.value - 1) * rankPageSize
    return pool.slice(start, start + rankPageSize)
})

const rankVisiblePages = computed(() => {
    const start = rankPageGroupStart.value
    const end = Math.min(rankTotalPages.value, start + rankDotWindowSize - 1)
    return Array.from({ length: end - start + 1 }, (_, i) => start + i)
})

const syncRankGroupByPage = (page) => {
    const nextStart = Math.floor((page - 1) / rankDotWindowSize) * rankDotWindowSize + 1
    rankPageGroupStart.value = nextStart
}

watch(rankPage, (page) => {
    syncRankGroupByPage(page)
})

const rankPrev = () => {
    if (rankTotalPages.value <= 1) return
    rankPage.value = rankPage.value <= 1 ? rankTotalPages.value : rankPage.value - 1
}
const rankNext = () => {
    if (rankTotalPages.value <= 1) return
    rankPage.value = rankPage.value >= rankTotalPages.value ? 1 : rankPage.value + 1
}

const handleRankDotClick = (page) => {
    const pages = rankVisiblePages.value
    const lastVisiblePage = pages[pages.length - 1]
    const hasNextGroup = lastVisiblePage < rankTotalPages.value

    // 与历史版本一致：点击最后一个点可切换到下一组 5 页
    if (page === lastVisiblePage && hasNextGroup) {
        const nextStart = rankPageGroupStart.value + rankDotWindowSize
        rankPageGroupStart.value = nextStart
        rankPage.value = nextStart
        return
    }
    rankPage.value = Math.min(Math.max(1, Number(page) || 1), rankTotalPages.value)
}

let rankCarouselTimer = null
const RANK_CAROUSEL_MS = 5000

function resumeRankCarousel() {
    if (rankCarouselTimer || rankTotalPages.value <= 1) return
    rankCarouselTimer = setInterval(() => {
        rankNext()
    }, RANK_CAROUSEL_MS)
}

function pauseRankCarousel() {
    if (rankCarouselTimer) {
        clearInterval(rankCarouselTimer)
        rankCarouselTimer = null
    }
}

watch(rankTotalPages, () => {
    pauseRankCarousel()
    resumeRankCarousel()
})

const incomeStations = ref({})
const fetchIncomeStations = async () => {
    loadingIncomeStations.value = true
    try {
        const range = timeRange.value
        const { startTime, endTime } = getIncomeQueryTimeRange(range)
        const params = {
            startTime,
            endTime,
            type: getIncomeStationsApiType(range)
        }
        const res = await getIncomeStations(params)
        if (res.code === 200 && res.data) {
            Object.assign(incomeStations.value, res.data)
        }
    } finally {
        loadingIncomeStations.value = false
    }
}

const mapFooterStats = computed(() => ({
    co2: formatWanStat(incomeStations.value.co2, 't'),
    tree: formatWanStat(incomeStations.value.tree, '棵'),
    coal: formatWanStat(incomeStations.value.coal, '吨'),
}))

const stationData = ref({})
const stationCapacityDisplay = computed(() => {
    const raw = stationData.value?.capacitySum
    if (raw == null || raw === '') return '--'
    const capacity = Number(raw)
    return Number.isFinite(capacity) ? formatterCapacity(capacity) : '--'
})

const fetchStationData = async () => {
    loadingStationData.value = true
    try {
        const res = await getStationData()
        if (res.code === 200 && res.data) {
            Object.assign(stationData.value, res.data)
        }
    } finally {
        loadingStationData.value = false
    }
}
onMounted(() => {
    fetchIncomAndPower(timeRange.value)
    fetchTodayIncome()
    fetchIncomeStations()
    fetchIncomeRanking()
    fetchStationData()
    todayIncomeTimer = setInterval(() => fetchTodayIncome({ showLoading: false }), 30 * 1000)
    resumeRankCarousel()
})

onBeforeUnmount(() => {
    if (todayIncomeTimer) {
        clearInterval(todayIncomeTimer)
        todayIncomeTimer = null
    }
    pauseRankCarousel()
    if (todayIncomeRafId) {
        cancelAnimationFrame(todayIncomeRafId)
        todayIncomeRafId = 0
    }
})
</script>

<style scoped>
.text-end {
    white-space: nowrap;
}

.power-station-page {
    display: flex;
    flex-direction: column;
    /* 与 AppMain.router-view-wrapper 配合：占满主内容区高度，不出现整页纵向滚动条 */
    flex: 1;
    min-height: 0;
    padding: clamp(8px, 1.2vw, 20px);
    color: #1d2a49;
    box-sizing: border-box;
    overflow: hidden;
}

.power-station-page :deep(.el-loading-mask) {
    background-color: transparent;
}

.content-wrap {
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
    gap: clamp(8px, 1vw, 14px);
    min-width: 0;
    width: 100%;
    overflow: hidden;
}

.card {
    border-radius: 30px;
    background: #ffffff3d;
    box-shadow: 0 0 5px #a9a9a926;
}

.top-bar {
    padding: 18px 24px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.top-bar h1 {
    margin: 0;
    font-size: clamp(26px, 3.2vw, 44px);
    line-height: 1;
}

.top-bar p {
    margin: 6px 0 0;
    font-size: 14px;
    color: #6678a0;
}

.top-metrics {
    display: flex;
    flex-wrap: wrap;
    gap: clamp(12px, 2vw, 28px);
}

.metric span {
    display: block;
    font-size: 13px;
    color: #7f8fb4;
}

.metric strong {
    display: block;
    margin-top: 4px;
    font-size: clamp(22px, 3vw, 42px);
    font-weight: 600;
}

/*
 * 主内容区占满可用宽度。此前 max-width:2400px + margin:auto 会在 4K 等超宽屏两侧留出大块空白；
 * ≤2400px 时 min(100%,2400px) 本就等于 100%，去掉上限不改变笔记本/常规分辨率表现。
 */
.dashboard-shell {
    width: 100%;
    max-width: 100%;
    margin-inline: 0;
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.dashboard-grid {
    display: grid;
    /*
     * 三列均衡：左右同权 1fr，中间略多 1.08fr（地球区略吃一点），避免左右过宽、中间过挤。
     */
    grid-template-columns:
        minmax(250px, 1fr) minmax(300px, 1.6fr) minmax(250px, 1fr);
    grid-template-rows: minmax(0, 1fr);
    gap: clamp(8px, 1vw, 16px);
    flex: 1;
    min-height: 0;
    align-items: stretch;
    overflow: hidden;
}

.left-panel,
.right-panel {
    display: flex;
    flex-direction: column;
    gap: clamp(8px, 1vw, 14px);
    min-width: 0;
    min-height: 0;
    overflow: hidden;
}

.left-panel>.info-card,
.right-panel>.info-card {
    flex: 0 0 auto;
}

.left-panel>.ranking-card {
    flex: 1 1 0;
    min-height: 0;
}

.info-card,
.ranking-card,
.chart-card {
    padding: 16px;
}

h3 {
    margin: 0 0 12px;
    font-size: 16px;
}

.info-card {
    padding: 22px 22px 18px;
}

.panel-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 18px;
}

.panel-title {
    display: flex;
    align-items: center;
    gap: 12px;
}

.panel-title h3 {
    margin: 0;
    font-size: 22px;
    font-weight: 700;
    letter-spacing: 0.2px;
}

.panel-title-text {
    color: #2E2E2E;
    font-feature-settings: 'liga' off, 'clig' off;
    font-family: "HarmonyOS Sans SC";
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 28px;
    /* 140% */
}

.panel-accent {
    width: 4px;
    height: 18px;
    border-radius: 2px;
    background: #2f6bff;
}

/* 收益排名：与运营管理「收益列表」同结构的表格 + 分页 */
.mps-ranking-stack {
    display: flex;
    flex-direction: column;
    min-height: 0;
}

.mps-table-wrap {
    margin-top: 4px;
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
}

.mps-revenue-table-inner {
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    max-width: 100%;
}

.mps-revenue-table {
    font-size: 13px;
    flex: 1;
    min-height: 0;
    background: transparent !important;
}

.mps-revenue-table :deep(.v-table__wrapper) {
    overflow-x: hidden;
    overflow-y: auto;
    scrollbar-gutter: stable;
    background: transparent !important;
}

.mps-revenue-table :deep(table) {
    border-collapse: collapse;
    width: 100%;
    table-layout: fixed;
    background: transparent;
}

.mps-revenue-table :deep(thead th),
.mps-revenue-table :deep(tbody td) {
    padding: 7px 10px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

.mps-revenue-table :deep(thead th) {
    vertical-align: middle;
    background: rgba(0, 0, 0, 0.02);
    color: rgba(46, 46, 46, 0.85);
    font-weight: 500;
    white-space: nowrap;
}

.mps-revenue-table :deep(tbody td) {
    vertical-align: middle;
}

.mps-revenue-table :deep(tbody tr:hover td) {
    background: rgba(230, 243, 255, 0.2);
}

.mps-station-cell {
    max-width: 100%;
    min-width: 0;
    vertical-align: middle;
}

.mps-station-name {
    min-width: 0;
    max-width: 100%;
}

.mps-station-text {
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: #2e2e2e;
    font-weight: 500;
    line-height: 1.35;
}

.mps-revenue-pagination {
    margin-top: auto;
    flex-shrink: 0;
}

.pagination-container {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 8px 0 0;
    background: transparent;
    width: 100%;
}

.pagination-info {
    font-family: 'PingFang SC', sans-serif;
    font-size: 13px;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.6);
}

.pagination-controls {
    display: flex;
    align-items: center;
    gap: 12px;
}

.rank-pager {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
}

.rank-arrow {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    border: 0;
    background: rgba(240, 243, 251, 0.9);
    color: rgba(46, 46, 46, 0.55);
    cursor: pointer;
    display: grid;
    place-items: center;
}

.rank-arrow:disabled {
    opacity: 0.35;
    cursor: not-allowed;
}

.rank-dots {
    display: flex;
    gap: 6px;
}

.rank-dot {
    width: 8px;
    height: 8px;
    border-radius: 999px;
    border: 0;
    background: rgba(46, 46, 46, 0.15);
    cursor: pointer;
}

.rank-dot.active {
    width: 18px;
    background: #2f6bff;
}

.panel-more {
    width: 28px;
    height: 28px;
    border-radius: 50%;
    border: 0;
    background: #f0f3fb;
    color: #b0bbd8;
    font-size: 18px;
    line-height: 1;
    cursor: pointer;
    display: grid;
    place-items: center;
}

.panel-big-row {
    border-radius: 20px;
    border: 1px solid #dbe6ff;
    background: #f7f9ff;
    padding: 0px 22px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.big-stat {
    flex: 1;
    text-align: left;
}

.big-label {
    color: rgba(46, 46, 46, 0.50);
    font-family: "HarmonyOS Sans SC";
    font-size: 14px;
    font-style: normal;
    font-weight: 300;
    line-height: normal;
}

.big-value {
    display: flex;
    align-items: baseline;
    justify-content: left;
    gap: 6px;
}

.big-number {
    color: #2E2E2E;
    font-family: "HarmonyOS Sans SC";
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
}

.big-unit {
    color: #2E2E2E;
    font-family: "HarmonyOS Sans SC";
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
}

.big-divider {
    width: 1px;
    height: 74px;
    margin: 0 18px;
}

.panel-bottom-row {
    margin-top: 18px;
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 10px;
}

.bottom-label {
    font-size: 14px;
    color: #a6b3d6;
    margin-bottom: 8px;
}

.bottom-value {
    display: inline-flex;
    align-items: baseline;
    gap: 6px;
}

.bottom-number {
    font-size: clamp(22px, 3.8vw, 42px);
    font-weight: 800;
    color: #2b2f3a;
}

.bottom-unit {
    color: #2E2E2E;

    font-family: "HarmonyOS Sans SC";
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
}

.income-box {
    border-radius: 20px;
    padding: 16px 0px;
}

.income-top-grid {
    display: grid;
    width: 100%;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 10px;
    justify-items: stretch;
    align-items: start;
}

.income-top-item {
    width: 100%;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.income-top-item .big-value {
    justify-content: center;
}

/* 三列等分基础上：左列靠左，中列居中，右列靠右 */
.income-top-grid>.income-top-item:nth-child(1) {
    align-items: flex-start;
    text-align: left;
}

.income-top-grid>.income-top-item:nth-child(2) {
    align-items: center;
    text-align: center;
}

.income-top-grid>.income-top-item:nth-child(3) {
    align-items: flex-end;
    text-align: right;
}

.income-top-grid>.income-top-item:nth-child(1) .big-value {
    justify-content: flex-start;
}

.income-top-grid>.income-top-item:nth-child(3) .big-value {
    justify-content: flex-end;
}

.income-bottom-grid {
    margin-top: 16px;
    display: grid;
    /* 下方收益信息：这里是 4 个统计项 */
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 10px;
}

/* 四列等分基础上：第1列靠左，第2/3列居中，第4列靠右 */
.income-bottom-grid>.bottom-stat {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.income-bottom-grid>.bottom-stat:nth-child(1) {
    align-items: flex-start;
    text-align: left;
}

.income-bottom-grid>.bottom-stat:nth-child(2) {
    align-items: center;
    text-align: center;
}

.income-bottom-grid>.bottom-stat:nth-child(3) {
    align-items: center;
    text-align: center;
}

.income-bottom-grid>.bottom-stat:nth-child(4) {
    align-items: flex-end;
    text-align: right;
}

/* 收益信息字体：继承基础信息面板的默认字号 */

.stat-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 10px;
}

.stat-item {
    border-radius: 10px;
    background: #f2f6ff;
    padding: 10px;
}

.stat-item span {
    display: block;
    color: #7d8cb0;
    font-size: 12px;
}

.stat-item strong {
    display: block;
    margin-top: 6px;
    font-size: 24px;
    font-weight: 600;
}

.ranking-card {
    flex: 1;
}

.progress-wrap {
    display: flex;
    align-items: center;
    gap: 8px;
}

.progress {
    flex: 1;
    height: 8px;
    background: #e5ecff;
    border-radius: 6px;
    overflow: hidden;
}

.progress i {
    display: block;
    height: 100%;
    border-radius: 6px;
    background: linear-gradient(90deg, #4a88ff 0%, #2d6bff 100%);
}

.progress-wrap strong {
    min-width: 42px;
    text-align: right;
    font-size: 12px;
}

.center-panel {
    position: relative;
    /* 与 dashboard 行高对齐：占满网格行，避免 min-vh 把整页撑出视口 */
    overflow-x: hidden;
    overflow-y: visible;
    min-height: 0;
    height: 100%;
    max-height: 100%;
    align-self: stretch;
    /* 为绝对定位的 map-footer 预留空间，避免与地球底边重叠或被父级裁切 */
    padding-bottom: clamp(80px, 12vh, 120px);
    box-sizing: border-box;
    min-width: 0;
    background: url('@/assets/earth.png') no-repeat center center;
    background-size: contain;
}

.map-connection-layer {
    position: absolute;
    inset: 0;
    pointer-events: none;
    z-index: 3;
}

.map-connection-svg {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
}

.map-connection-path {
    fill: none;
    stroke: #34d26f;
    stroke-width: 3.2;
    stroke-linecap: round;
    stroke-linejoin: round;
    filter: drop-shadow(0 8px 10px rgba(34, 210, 111, 0.18));
}

.map-marker-icon {
    position: absolute;
    left: 50%;
    top: clamp(28%, 36vh, 40%);
    width: clamp(44px, 5vw, 72px);
    height: clamp(44px, 5vw, 72px);
    transform: translate(-50%, -50%);
    object-fit: contain;
    filter: drop-shadow(0 14px 18px rgba(34, 210, 111, 0.16));
}

.map-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    opacity: 0.95;
}

.map-overlay {
    position: absolute;
    top: clamp(12px, 4vh, 56px);
    right: clamp(12px, 2.5vw, 58px);
    max-width: min(320px, calc(100% - 24px));
    padding: clamp(12px, 1.4vw, 18px) clamp(14px, 1.6vw, 22px);
    border-radius: 16px;
    background: #ffffff29;
    border: 1px solid #789bff59;
    box-shadow: 0 22px 44px rgba(30, 76, 180, 0.12);
    backdrop-filter: blur(10px);
}

.map-overlay-title {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 16px;
}

.map-overlay-pin {
    width: 12px;
    height: 12px;
    display: inline-block;
    border-radius: 50% 50% 50% 0;
    transform: rotate(-45deg);
    background: #7FA0FF;
    box-shadow: 0 8px 18px rgba(47, 107, 255, 0.08);
    position: relative;
}

.map-overlay-pin::after {
    content: '';
    position: absolute;
    width: 7px;
    height: 7px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.85);
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

.map-overlay-title-text {
    font-size: 14px;
    font-weight: 700;
    color: rgba(46, 46, 46, 0.7);
    letter-spacing: 0.4px;
}

.map-overlay-row {
    display: flex;
    align-items: baseline;
    gap: 10px;
    margin-top: 10px;
}

.map-overlay-label {
    font-size: 14px;
    color: rgba(46, 46, 46, 0.6);
    letter-spacing: 0.2px;
    text-align: right;
}

.map-overlay-value {
    color: #373737;

    font-family: "HarmonyOS Sans SC";
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    text-align: left;
}

.map-footer {
    position: absolute;
    left: 50%;
    bottom: clamp(12px, 2.5vh, 30px);
    transform: translateX(-50%);
    z-index: 4;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: min(450px, calc(100% - 20px));
    padding: 8px 12px;
    /* background: rgba(255, 255, 255, 0.78); */
    /* 只做四角角标线（不走整框描边） */
    border: 0;
    background-image:
        linear-gradient(rgba(108, 163, 255, 0.85), rgba(108, 163, 255, 0.85)),
        linear-gradient(rgba(108, 163, 255, 0.85), rgba(108, 163, 255, 0.85)),
        linear-gradient(rgba(108, 163, 255, 0.85), rgba(108, 163, 255, 0.85)),
        linear-gradient(rgba(108, 163, 255, 0.85), rgba(108, 163, 255, 0.85)),
        linear-gradient(rgba(108, 163, 255, 0.85), rgba(108, 163, 255, 0.85)),
        linear-gradient(rgba(108, 163, 255, 0.85), rgba(108, 163, 255, 0.85)),
        linear-gradient(rgba(108, 163, 255, 0.85), rgba(108, 163, 255, 0.85)),
        linear-gradient(rgba(108, 163, 255, 0.85), rgba(108, 163, 255, 0.85));
    background-size:
        26px 2px,
        26px 2px,
        26px 2px,
        26px 2px,
        2px 26px,
        2px 26px,
        2px 26px,
        2px 26px;
    background-position:
        top left,
        top right,
        bottom left,
        bottom right,
        top left,
        top right,
        bottom left,
        bottom right;
    background-repeat: no-repeat;
    box-shadow: 0 18px 54px rgba(26, 67, 153, 0.14);
    backdrop-filter: blur(10px);
}

.map-footer-item {
    flex: 1;
    text-align: center;
}

.map-footer-icon {
    width: 54px;
    height: 54px;
    object-fit: contain;
    display: block;
    margin: 0 auto 8px;
    filter: drop-shadow(0 10px 18px rgba(31, 78, 255, 0.12));
}

.map-footer-value {
    display: inline-flex;
    align-items: baseline;
    gap: 4px;
    color: #2e2e2e;
}

.map-footer-value .num {
    color: #2E2E2E;
    font-family: "HarmonyOS Sans SC";
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
}

.map-footer-value .unit {
    color: #2E2E2E;
    font-family: "HarmonyOS Sans SC";
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
}

.map-footer-label {
    color: #6A727C;

    font-family: "HarmonyOS Sans SC";
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
}

.chart-card {
    flex: 1;
    min-height: 0;
    padding: clamp(14px, 1.4vw, 20px);
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.chart-block {
    margin-top: 4px;
    position: relative;
    width: 100%;
    flex: 1 1 0;
    min-height: clamp(96px, 14vh, 200px);
    height: 0;
}

.chart-block--area {
    min-height: clamp(100px, 15vh, 220px);
}

.chart-card :deep(.chart) {
    display: block;
    width: 100%;
    height: 100%;
    min-height: 0;
}

.chart-head {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    margin-bottom: 10px;
}

.chart-tabs {
    display: inline-flex;
    align-items: center;
    gap: 16px;
    padding: 4px;
    border-radius: 999px;
    background: #F3F6FF;
    box-shadow: 0 4px 12px #3a68ff14;
}

.chart-tab {
    border: 0;
    min-width: 68px;
    padding: 6px 18px;
    border-radius: 999px;
    background: transparent;
    color: rgba(46, 46, 46, 0.65);
    font-size: 14px;
    cursor: pointer;
    transition: all 0.2s;
}

.chart-tab.is-active {
    background: #3A68FF;
    color: #fff;
    box-shadow: 0 6px 16px rgba(58, 104, 255, 0.35);
}

.chart-section {
    margin-top: 10px;
    flex: 1 1 0;
    min-height: 0;
    display: flex;
    flex-direction: column;
    min-width: 0;
}

.chart-section:first-of-type {
    margin-top: 6px;
}

.chart-section-title {
    color: #9aa6c9;
    font-size: 14px;
    margin-bottom: 8px;
}

.chart-section-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    margin-bottom: 6px;
}

.chart-legend {
    display: flex;
    gap: 14px;
    color: #8d99c2;
    font-size: 12px;
    align-items: center;
}

.legend-item {
    display: inline-flex;
    gap: 8px;
    align-items: center;
}

.legend-dot {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    display: inline-block;
}

.legend-charge {
    background: #28d17c;
}

.legend-discharge {
    background: #3b7bff;
}

.bar-chart {
    position: relative;
    border-radius: 12px;
    padding-top: 6px;
}

.bar-y-labels {
    position: absolute;
    left: 0;
    top: 10px;
    bottom: 30px;
    width: 52px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    color: #a8b5d8;
    font-size: 12px;
    padding-left: 6px;
}

.bar-row {
    padding-left: 58px;
    display: flex;
    gap: 14px;
    height: 120px;
    align-items: end;
    background:
        linear-gradient(to top, rgba(229, 238, 255, 1) 1px, transparent 1px) 58px 0 / 100% 30px repeat-y;
}

.bar-item {
    flex: 1;
    min-width: 14px;
    border-radius: 7px 7px 0 0;
    background: linear-gradient(180deg, #6ea1ff 0%, #2d6bff 100%);
}

.bar-x-labels {
    padding-left: 58px;
    display: flex;
    justify-content: space-between;
    color: #b0bddf;
    font-size: 12px;
    margin-top: 6px;
}

.area-chart {
    display: flex;
    margin-top: 6px;
}

.area-y-labels {
    width: 52px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    color: #a8b5d8;
    font-size: 12px;
    padding: 10px 0 26px 6px;
}

.area-visual {
    position: relative;
    flex: 1;
    height: 140px;
    border-radius: 12px;
    overflow: hidden;
    background: linear-gradient(180deg, rgba(231, 245, 255, 0.85) 0%, rgba(248, 251, 255, 0.95) 100%);
}

.area-grid {
    position: absolute;
    inset: 0;
    background:
        linear-gradient(to top, rgba(229, 238, 255, 1) 1px, transparent 1px) 0 0 / 100% 30px repeat-y;
}

.area-fill {
    position: absolute;
    left: -6%;
    width: 112%;
    height: 70%;
    bottom: -14px;
    border-radius: 60% 40% 40% 60% / 60% 60% 40% 40%;
    filter: blur(0.2px);
}

.area-fill.charge {
    background: rgba(40, 209, 124, 0.18);
    transform: translateY(12px);
}

.area-fill.discharge {
    background: rgba(59, 123, 255, 0.22);
    transform: translateY(18px);
}

.area-line {
    position: absolute;
    left: -4%;
    width: 108%;
    height: 70%;
    border-radius: 42% 58% 45% 55% / 50% 55% 45% 50%;
}

.area-line.line-a {
    bottom: 14px;
    background: rgba(40, 209, 124, 0.55);
}

.area-line.line-b {
    bottom: 4px;
    background: rgba(59, 123, 255, 0.55);
}

.area-dot {
    position: absolute;
    left: 78%;
    top: 22%;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: #28d17c;
    box-shadow: 0 0 0 4px rgba(40, 209, 124, 0.12);
}

.chart-bars {
    display: flex;
    align-items: end;
    gap: 10px;
    height: 120px;
    margin-bottom: 16px;
}

.chart-bars span {
    flex: 1;
    border-radius: 6px 6px 0 0;
    background: linear-gradient(180deg, #70a1ff 0%, #2f73ff 100%);
}

.chart-lines {
    position: relative;
    height: 90px;
    border-radius: 10px;
    background: linear-gradient(180deg, rgba(225, 241, 255, 0.8) 0%, rgba(248, 252, 255, 0.9) 100%);
    overflow: hidden;
}

.line {
    position: absolute;
    left: -4%;
    width: 108%;
    height: 70%;
    border-radius: 42% 58% 45% 55% / 50% 55% 45% 50%;
}

/* 适配较小屏幕 - 宽度小于1400px或高度小于800px */
@media (max-width: 1400px),
(max-height: 800px) {
    .power-station-page {
        padding: 12px;
    }

    .content-wrap {
        gap: 10px;
    }

    .dashboard-grid {
        gap: 10px;
        grid-template-columns:
            minmax(250px, 1.12fr) minmax(250px, 1.18fr) minmax(250px, 1.12fr);
    }

    .info-card {
        padding: 16px;
    }

    .panel-title h3 {
        font-size: 18px;
    }

    .panel-title-text {
        font-size: 14px;
        line-height: 24px;
    }

    .panel-header {
        margin-bottom: 14px;
    }

    .panel-big-row {
        padding: 0 16px;
        border-radius: 16px;
    }

    .big-label {
        font-size: 12px;
    }

    .big-number {
        font-size: 16px;
    }

    .big-unit {
        font-size: 11px;
    }

    .big-divider {
        height: 56px;
        margin: 0 12px;
    }

    .panel-bottom-row {
        margin-top: 14px;
        gap: 8px;
    }

    .income-box {
        padding: 12px 0;
        border-radius: 16px;
    }

    .income-top-grid {
        gap: 8px;
    }

    .income-bottom-grid {
        margin-top: 12px;
        gap: 8px;
    }

    .card {
        border-radius: 20px;
    }

    .chart-card {
        padding: 12px;
    }

    .chart-tab {
        min-width: 56px;
        padding: 4px 14px;
        font-size: 12px;
    }

    .chart-section-title {
        font-size: 12px;
        margin-bottom: 6px;
    }

    .map-overlay {
        padding: 10px 12px;
        top: 10px;
        right: 10px;
    }

    .map-overlay-title {
        margin-bottom: 12px;
        gap: 8px;
    }

    .map-overlay-title-text {
        font-size: 12px;
    }

    .map-overlay-row {
        margin-top: 8px;
        gap: 8px;
    }

    .map-overlay-label,
    .map-overlay-value {
        font-size: 12px;
    }

    .center-panel {
        padding-bottom: clamp(70px, 10vh, 110px);
    }

    .map-footer {
        bottom: 12px;
        width: min(380px, calc(100% - 20px));
        padding: 8px;
    }

    .map-footer-icon {
        width: 42px;
        height: 42px;
        margin-bottom: 4px;
    }

    .map-footer-value .num {
        font-size: 14px;
    }

    .map-footer-value .unit,
    .map-footer-label {
        font-size: 10px;
    }

    .mps-revenue-table {
        font-size: 12px;
    }

    .mps-revenue-table :deep(thead th),
    .mps-revenue-table :deep(tbody td) {
        padding: 5px 8px;
    }

    .rank-arrow {
        width: 20px;
        height: 20px;
    }

    .rank-dot {
        width: 6px;
        height: 6px;
    }

    .rank-dot.active {
        width: 14px;
    }
}

/* 适配2560×1600在150%缩放下的可视宽度 */
@media (min-width: 1501px) and (max-width: 1800px) {
    .dashboard-grid {
        grid-template-columns:
            minmax(300px, 1.18fr) minmax(320px, 1.05fr) minmax(300px, 1.18fr);
    }
}

/* 适配2560×1440及以上大屏幕 */
@media (min-width: 2560px) {
    .power-station-page {
        padding: 30px;
    }

    .content-wrap {
        gap: 24px;
    }

    .dashboard-grid {
        gap: 24px;
        grid-template-columns:
            minmax(350px, 1fr) minmax(450px, 1.6fr) minmax(350px, 1fr);
    }

    .card {
        border-radius: 36px;
    }

    .info-card {
        padding: 32px;
    }

    .panel-title h3 {
        font-size: 30px;
    }

    .panel-title-text {
        font-size: 22px;
        line-height: 36px;
    }

    .panel-accent {
        width: 5px;
        height: 24px;
    }

    .panel-header {
        margin-bottom: 26px;
    }

    .panel-big-row {
        padding: 0 32px;
        border-radius: 28px;
    }

    .big-label {
        font-size: 18px;
    }

    .big-number {
        font-size: 28px;
    }

    .big-unit {
        font-size: 16px;
    }

    .big-divider {
        height: 96px;
        margin: 0 24px;
    }

    .panel-bottom-row {
        margin-top: 24px;
        gap: 16px;
    }

    .income-box {
        padding: 24px 0;
        border-radius: 28px;
    }

    .income-top-grid {
        gap: 16px;
    }

    .income-bottom-grid {
        margin-top: 22px;
        gap: 16px;
    }

    .chart-card {
        padding: 28px;
    }

    .chart-head {
        margin-bottom: 16px;
    }

    .chart-tab {
        min-width: 90px;
        padding: 10px 24px;
        font-size: 16px;
    }

    .chart-section-title {
        font-size: 16px;
        margin-bottom: 12px;
    }

    .chart-block {
        min-height: clamp(140px, 14vh, 280px);
    }

    .chart-block--area {
        min-height: clamp(150px, 15vh, 300px);
    }

    .map-overlay {
        padding: 20px 26px;
        top: 24px;
        right: 24px;
        border-radius: 20px;
    }

    .map-overlay-title {
        margin-bottom: 20px;
        gap: 12px;
    }

    .map-overlay-pin {
        width: 16px;
        height: 16px;
    }

    .map-overlay-title-text {
        font-size: 16px;
    }

    .map-overlay-row {
        margin-top: 12px;
        gap: 12px;
    }

    .map-overlay-label {
        font-size: 16px;
    }

    .map-overlay-value {
        font-size: 20px;
    }

    .map-footer {
        bottom: 16px;
        width: min(520px, calc(100% - 48px));
        padding: 8px;
    }

    .map-footer-icon {
        width: 72px;
        height: 72px;
        margin-bottom: 10px;
    }

    .map-footer-value .num {
        font-size: 24px;
    }

    .map-footer-value .unit,
    .map-footer-label {
        font-size: 14px;
    }

    .mps-revenue-table {
        font-size: 15px;
    }

    .mps-revenue-table :deep(thead th),
    .mps-revenue-table :deep(tbody td) {
        padding: 10px 14px;
    }

    .rank-arrow {
        width: 32px;
        height: 32px;
        font-size: 18px;
    }

    .rank-dot {
        width: 10px;
        height: 10px;
    }

    .rank-dot.active {
        width: 22px;
    }

    .ranking-card {
        padding: 24px;
    }
}

.line-a {
    bottom: 8px;
    background: rgba(45, 112, 255, 0.35);
}

.line-b {
    bottom: -10px;
    background: rgba(91, 208, 173, 0.4);
}

.info-card-left .bottom-stat,
.big-stat {
    white-space: nowrap;
    padding-left: 46px;
}

@media (max-width: 1500px) {
    .dashboard-grid {
        grid-template-columns:
            minmax(230px, 1fr) minmax(280px, 1.08fr) minmax(230px, 1fr);
    }

    .top-bar h1 {
        font-size: clamp(24px, 3vw, 36px);
    }

    .metric strong {
        font-size: clamp(20px, 2.8vw, 36px);
    }
}

@media (max-width: 1320px) {
    .dashboard-grid {
        grid-template-columns: 1fr;
        grid-template-rows: none;
        flex: 0 1 auto;
        min-height: auto;
        overflow: visible;
    }

    .center-panel {
        order: -1;
        min-height: clamp(240px, 36vh, 420px);
        height: auto;
        max-height: none;
    }

    .left-panel,
    .right-panel {
        flex-direction: column;
    }
}

@media (max-width: 900px) {
    .top-metrics {
        width: 100%;
        justify-content: flex-start;
    }

    .income-top-grid {
        grid-template-columns: 1fr;
        gap: 14px;
    }

    .income-top-grid>.income-top-item:nth-child(1),
    .income-top-grid>.income-top-item:nth-child(2),
    .income-top-grid>.income-top-item:nth-child(3) {
        align-items: center;
        text-align: center;
    }

    .income-top-grid>.income-top-item:nth-child(1) .big-value,
    .income-top-grid>.income-top-item:nth-child(3) .big-value {
        justify-content: center;
    }

    .income-bottom-grid {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }
}
</style>
